import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '/styles/pstlandingpage.module.scss'
import { Button } from "react-bootstrap";
import CustomImage from "../CustomImage"; 
import router from "next/router";
import useZipmeLink from "../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../utils/helpers";

interface Props {
    data: any;
    jotformId: any;
    bgColor: any;
    externalLink: any;
}
const ElanLoan: React.FC<Props> = ({ data, jotformId, bgColor, externalLink }) => {
    const { zipmeLink, generateLink } = useZipmeLink();
    return (
        <>
            <div className={styles.capabilityBg} style={{ backgroundColor: bgColor || "#fffff" }}>
                <Container>
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                            <div>
                                <CustomImage src={data?.imagePath || "/images/partners/partner1.svg"} alt={data?.imageAltTag} height={430} width={480} />
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                            <div className="mb-4">
                                <h2>{data?.title}</h2>
                            </div>
                            <div className={styles.content}>
                                <p>{data?.description}</p>
                            </div>
                            <div>
                                {
                                    data?.points?.length > 0 &&
                                    data?.points?.map((text: any) => {
                                        return (
                                            <div className={styles.subcontent}>
                                                <h4>{text.title}</h4>
                                                <p>{text.description}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div>
                                <Button onClick={() => {
                                    !jotformId && generateLink(externalLink)
                                }}
                                    className={`${isFrappeOrJotFormClass(jotformId)}`} >
                                    { data.button?.label || 'Enquire Now' }
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}
export default ElanLoan;